'use client';
import { CosmicHelperWrapper } from '@finn/platform-modules';
import { DiscoveryConfigProvider } from '@finn/ua-vehicle';
import { ModuleHelperWrapper } from '@finn/ui-cosmic';
import { parseToHtml, useUniversalRouter } from '@finn/ui-utils';
import get from 'lodash/get';
import React from 'react';

import HeadTags from '~/components/HeadTags';
import SpacingBox from '~/components/SpacingBox';
import Page from '~/layouts/Default';
import { TermItem, TermsPageData } from '~/types/cosmicModules';

export type TermsProps = {
  pageData: TermsPageData;
};

export const Terms = ({ pageData }: TermsProps) => {
  const router = useUniversalRouter();

  return (
    <DiscoveryConfigProvider router={router}>
      <CosmicHelperWrapper data={pageData} preview={false} />
      <Page data={pageData}>
        <HeadTags />
        <SpacingBox>
          <div className="container">
            <div className="mx-auto my-0 max-w-6xl sm:pb-20">
              <h1 className="mobile-t1-semibold md:web-t1-semibold mb-10 md:mb-12">
                {parseToHtml(get(pageData, 'metadata.title', ''))}
              </h1>
              <h5 className="mobile-t4-semibold md:web-t4-semibold mb-10 md:mb-14">
                {parseToHtml(get(pageData, 'metadata.subtitle', ''))}
              </h5>
              {pageData.metadata.terms.map((term: TermItem, i) => (
                <div
                  className="mb-12 last:mb-0 sm:mb-14 md:mb-16"
                  key={`${term.metadata.title}-${i}-${term.slug}`}
                >
                  <ModuleHelperWrapper data={term} isBoxed>
                    <h5 className="global-t5-semibold mb-4" id={`section-${i}`}>
                      {parseToHtml(term.metadata.title)}
                    </h5>
                    <div className="body-16-light">
                      {parseToHtml(term.metadata.content)}
                    </div>
                  </ModuleHelperWrapper>
                </div>
              ))}
            </div>
          </div>
        </SpacingBox>
      </Page>
    </DiscoveryConfigProvider>
  );
};
